import './UploadTagSheetDrawer.scss';

import { bem } from 'mission-control-common-components';
import React from 'react';

import Drawer from '../../../../common/Drawer';
import type { UploadTagSheetDrawerData } from '../../TraffickingPage/hooks/makePageDrawerPlugin';
import UploadTagSheetContent from './components/UploadTagSheetContent/UploadTagSheetContent';

type Props = {
  isOpen: boolean;
  data: UploadTagSheetDrawerData;
  onClose: () => void;
  onToggleExpansion: () => void;
};

const [block] = bem('upload-tag-sheet-drawer');

const UploadTagSheetDrawer = ({ data, isOpen, onClose, onToggleExpansion }: Props): JSX.Element => {
  return (
    <Drawer<UploadTagSheetDrawerData>
      data={data}
      content={UploadTagSheetContent}
      onClose={onClose}
      isOpen={isOpen}
      isExpanded={true}
      onToggleExpansion={onToggleExpansion}
      emptyHeader={true}
      className={block()}
    />
  );
};

export default UploadTagSheetDrawer;
